import type { GroupType } from "./orderTypes";

export const GROUP_TYPE_OPTIONS: readonly { readonly value: GroupType; readonly label: string }[] = [
  { value: "ADULT_GROUP", label: "autokarowa grupowa" },
  { value: "SCHOOL_GROUP", label: "autokarowa szkolna" },
  { value: "INDIVIDUAL_SALE", label: "autokarowa indywidualna" },
  { value: "SENIORS", label: "autokarowa seniorzy" },
  { value: "PLANE_TICKET", label: "bilet lotniczy" },
  { value: "MICE", label: "MICE" },
  { value: "PLANE_SCHOOL", label: "lotnicza szkolna" },
  { value: "PLANE_GROUP", label: "lotnicza grupowa" },
  { value: "PLANE_INDIVIDUAL", label: "lotnicza indywidualna" },
  { value: "PLANE_SENIORS", label: "lotnicza seniorzy" },
];
